import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'kt-fileReturn',
  templateUrl: './fileReturn.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileReturnComponent {

}


